const codes = Object.freeze({
  NotAvailable: "NOT AVAILABLE",
});

export default codes;
